// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function animation() {

    var self          = this,
        $cache        = {},
        tl            = false;

    /**
     * Open Animation
     */
    function openAnimation() {
      if(env.device.mobile) return;

      tl = new TimelineMax({paused: true, delay: 0.3, onComplete: function(){
        //Removes animation style
        $cache.opacity.removeClass('js-animate-set');
        $cache.rlo.removeClass('js-animate-set');
      }});


      if($cache.rlo.length > 0) {
        tl.staggerFromTo($cache.rlo, 0.6, {opacity: 0}, {opacity: 1, ease: Expo.easeIn}, 0.075, 0);
        tl.staggerFromTo($cache.rlo, 0.9, {x: 150}, {x: 0, force3D:true, ease: Quart.easeOut}, 0.075, 0);
      }

      if($cache.rlo.length > 0) {
        tl.fromTo($cache.opacity, 0.6, {opacity: 0}, {opacity: 1, ease: Quad.easeOut}, 0.4);
      }

      if($cache.bto.length > 0) {
        tl.staggerFromTo($cache.bto, 0.6, {opacity: 0}, {opacity: 1, ease: Expo.easeIn}, 0.075, 0.3);
        tl.staggerFromTo($cache.bto, 0.9, {y: 150}, {y: 0, force3D:true, ease: Quart.easeOut}, 0.075, 0.3);
      }
    }

    /**
     * Play Animation
     */
    self.playAnimation = function() {
      if(env.device.mobile) return;

      tl.play();
    }


    /**
     * Init Cache
     */
    function initCache(target) {
      $cache.main = target;
      $cache.opacity = $cache.main.find('.js-animate-opacity');
      $cache.rlo = $cache.main.find('.js-animate-rlo');
      $cache.bto = $cache.main.find('.js-animate-bto');
    }

    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(target) {
      initCache(target);
      
      // Initial call on load
      openAnimation();
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.animation = animation;
  
}(jQuery));
